import React, { useState } from 'react';
import { Chess } from 'chess.js';
import { Chessboard } from 'react-chessboard';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const ConsultingChessBoard = () => {
  const [game, setGame] = useState(new Chess());

  function onDrop(sourceSquare, targetSquare) {
    try {
      const gameCopy = new Chess(game.fen());
      const move = gameCopy.move({
        from: sourceSquare,
        to: targetSquare,
        promotion: 'q'
      });

      if (move === null) {
        return false;
      }

      setGame(gameCopy);
      
      // Computer response
      setTimeout(() => {
        const moves = gameCopy.moves();
        if (moves.length > 0) {
          const randomMove = moves[Math.floor(Math.random() * moves.length)];
          gameCopy.move(randomMove);
          setGame(new Chess(gameCopy.fen()));
        }
      }, 200);
      
      return true;
    } catch (error) {
      return false;
    }
  }

  function resetGame() {
    setGame(new Chess());
  }

  return (
    <div className="flex flex-col">
      {/* Debug Info */}
      {/* <div className="text-xs text-gray-400 mb-2">
        Game: {game.fen().split(' ')[0]} | Turn: {game.turn() === 'w' ? 'White' : 'Black'}
      </div> */}
      
      {/* Chessboard - With Drag Fixes */}
      <div style={{ 
        userSelect: 'none', 
        pointerEvents: 'auto', 
        touchAction: 'none',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        overflow: 'hidden'
      }}>
        <Chessboard 
          position={game.fen()} 
          onPieceDrop={onDrop}
          boardOrientation="white"
          arePiecesDraggable={true}
          customSquareStyles={{}}
          customDarkSquareStyle={{ backgroundColor: '#3066be' }}
          customLightSquareStyle={{ backgroundColor: '#eeeed2' }}
        />
      </div>
      
      {/* Title and Subtitle Below - Like Other Widgets */}
      <div className="text-center mt-2">
        <a 
          href="https://chessweb.site" 
          target="_blank" 
          rel="noopener noreferrer"
          className="block hover:opacity-80 transition-opacity duration-200"
        >
          <div className="text-xs font-bold text-gray-100">
            Chess Apps
          </div>
          <div className="text-xs leading-tight mt-0.5 text-gray-400 flex items-center justify-center gap-1">
            build anything
            <FontAwesomeIcon icon={faArrowRight} className="text-[8px]" />
          </div>
        </a>
      </div>
      
      {/* Reset Button */}
      {game.isGameOver() && (
        <div className="text-center mt-2">
          <button 
            onClick={resetGame}
            className="text-xs text-blue-400 hover:text-blue-300 cursor-pointer"
          >
            Reset Game
          </button>
        </div>
      )}
    </div>
  );
};

export default ConsultingChessBoard;